module.exports = __webpack_public_path__ + "static/PrimitiveFour-9aa4389c2aafe6de5de0e2389602722f.png";